import PropTypes from 'prop-types';
import cn from "../../../../../utils/cn";
import { noop } from 'lodash';
import AddRemoveButtons from "../../../AddRemoveButtons/AddRemoveButtons";
import { jsx as _jsx } from "react/jsx-runtime";
const ProviderCardAddRemoveButton = props => {
  const {
    destinationLatLng = [],
    className = '',
    selected = false,
    onAddClick = noop,
    onRemoveClick = noop
  } = props;
  const providerCardAdd = () => {
    onAddClick(destinationLatLng);
  };
  return /*#__PURE__*/_jsx("div", {
    className: cn('flex border-l bg-light-fill-grey w-12', className),
    children: /*#__PURE__*/_jsx(AddRemoveButtons, {
      index: selected ? 2 : 0,
      length: selected ? 2 : 1,
      onAddClick: providerCardAdd,
      onRemoveClick: onRemoveClick,
      className: "m-auto",
      color: selected ? 'red' : 'brand-blue'
    })
  });
};
ProviderCardAddRemoveButton.propTypes = {
  className: PropTypes.string,
  destinationLatLng: PropTypes.array,
  onAddClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  selected: PropTypes.bool
};
export default ProviderCardAddRemoveButton;
//# sourceMappingURL=ProviderCardAddRemoveButton.js.map